import { render } from "./sideBar.vue?vue&type=template&id=521589c5&scoped=true&ts=true"
import script from "./sideBar.vue?vue&type=script&lang=ts"
export * from "./sideBar.vue?vue&type=script&lang=ts"

import "./sideBar.vue?vue&type=style&index=0&id=521589c5&lang=less"
import "./sideBar.vue?vue&type=style&index=1&id=521589c5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_e1bdad7a4b23a28f51493789fcc92ed5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521589c5"]])

export default __exports__